import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddProductToQuickOrderParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/quickOrder/trackAddProductToQuickOrder";

const useTrackAddProductToQuickOrder = (
    parameters: TrackAddProductToQuickOrderParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.addProductToQuickOrder, parameters, options);
};

export default useTrackAddProductToQuickOrder;
